import { render, staticRenderFns } from "./modalAddTicketsMatch.vue?vue&type=template&id=12672cd9&"
import script from "./modalAddTicketsMatch.vue?vue&type=script&lang=js&"
export * from "./modalAddTicketsMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports